// export default {
// 	host:'http://localhost',
// 	port:2465,
// 	socketurl:'ws://localhost:3469'
// }

// export default {
// 	host:'http://bgyxrtc0.haoleen.com',
// 	port:2465,
// 	socketurl:'ws://bgyxrtc0.haoleen.com:3469'
// }

export default {
	host:'https://amkir.node.99kuaifa.top',
	port:2469,
	socketurl:'wss://amkir.node.99kuaifa.top:3469'
}